import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FAQSection from '@/pages/home/components/FAQSection';
import AboutSection from '@/pages/home/components/AboutSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <FAQSection />
        <AboutSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
        <RankingSection />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <UpdatesSection />
        <IndexSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}